/**
 *
 * 使用方法
 *
 * 先调用 init_L 方法初始化
 *
 * 然后使用 _.XXX 获取具体值
 *
 */

var default_ = {
  en: {
    // 按鈕類
    Back: "Back",
    "Warm reminder": "Warm reminder",
    confirm: "confirm",
    cancel: "cancel",
    male: "Male",
    female: "Female",
    secrecy: "secrecy",
    Submit: "Submit",
    // 提示類
    "Please enter your mobile number": "Please enter your mobile number",
    "Please enter a password of at least 6 digits":
      "Please enter a password of at least 6 digits",
    "Login...": "Login...",
    "Login successfully": "Login successfully",
    "Please check the service agreement": "Please check the service agreement",
    "Registration success": "Registration success",
    "Please enter the confirmation password":
      "Please enter the confirmation password",
    "The two passwords are inconsistent": "The two passwords are inconsistent",
    "Password reset succeeded": "Password reset succeeded",
    Loading: "Loading...",
    "Update success": "Update success",
    "SMS sending": "SMS sending",
    "SMS code not correct": "SMS code not correct",
    "Invalid password": "Invalid password",
    "Login error, user or password not correct":
      "Login error, user or password not correct",
    "Identity expired": "Identity expired",
    "Network instability, please try again":
      "Network instability, please try again",
    "No more data": "No more data~",
    // 登錄
    Login: "Login",
    "Login to get offer": "Login to get offer",
    "Mobile number": "Mobile number",
    "Enter your mobile number": "Enter your mobile number",
    "Mobile number format error": "Mobile number format error",
    "Please enter the password": "Please enter the password",
    Password: "Password",
    "Enter your password within 6-20 words":
      "Enter your password within 6-20 words",
    "Forget password": "Forget password",
    "Create Account": "Create Account",
    "No account, go to register1": "No account, go to ",
    "No account, go to register2": "&nbsp;register",
    // 註冊
    "Welcome to join Us": "Welcome to join Us",
    "Join the membershio to get offer": "Join the membership to get offer",
    "Verification code": "Verification code",
    "Enter the verification code": "Enter the verification code",
    "verification code": "verification code",
    "Regain validation code": "Regain validation code",
    "Please read and agree terms and conditions ":
      "Please read and agree terms and conditions ",
    "terms and conditions ": "terms and conditions ",
    "to become member of The Food Story": "to become member of BRANDNAME",
    // 详细信息
    "Please ent this following information":
      "Please enter the following information",
    "Account name": "Account name",
    "Enter you account name": "Enter you account name",
    Mr: "Gender",
    "Your birthday": "Your birthday",
    "Enter your birthday": "Enter your birthday",
    Email: "Email",
    "Enter your Email": "Enter your Email",
    Skip: "Skip",
    Done: "Done",
    "Choosing birthday": "Choosing birthday",
    "Incorrect mailbox format": "Incorrect mailbox format",
    "Choose your gender": "Choose your gender",
    // 底部導航欄
    Membership: "Membership",
    Shop: "Shop",
    Profile: "Profile",
    // 會員卡頁
    "There are 1": "",
    coupons: "coupons",
    "There are 2": "",
    points: "points",
    // 取回密碼
    "Forget password": "Forget password",
    Next: "Next",
    // 更改密碼
    "Change password": "Change password",
    "Please enter a new password": "Please enter a new password",
    "Please confirm the new password": "Please confirm the new password",
    "confirm revision": "Confirm",
    "Please enter the old password": "Please enter the old password",
    "Old password": "Old password",
    "New password": "New password",
    "Confirm password": "Confirm password",
    // 我的
    Birthday: "Birthday",
    Sexual: "Gender",
    "Login password": "Change Password",
    Address: "Address",
    "Account name 2": "Name",
    "Email 2": "Email",
    "Mobile number 2": "Mobile number",
    "Modify name": "Modify name",
    "Modify email": "Modify email",
    "Revision of birthday": "Birthday",
    "Gender modification": "Gender",
    "Confirm logout": "Confirm logout",
    "Please enter a name": "Please enter a name",
    "Please enter email": "Please enter email",
    Logout: "Logout",
    "update language": "Language",
    "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?":
      "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?",
    // 更改手機號
    "Change phone number": "Change phone number",
    "This number is registered": "This number is registered",
    // 積分換購
    "Gift redemption": "Gift redemption",
    Point: "Point",
    Points: "Points",
    "Transaction record": "Transaction record",
    "Out of stoce": "Out of stoce",
    // 我的優惠券
    "My coupon": "My coupon",
    Available: "Available",
    Used: "Used",
    Expired: "Expired",
    "Validity period": "Validity period",
    // 下拉刷新
    "Drop down to refresh": "Drop down to refresh",
    "Release refresh now": "Release refresh now",
    "Refresh success": "Refresh success",
    "No more data": "No more data",
    // 優惠券詳情
    "Coupon details": "Coupon details",
    // 積分記錄
    "Total Bill": "Total Amount",
    Coupon: "Use Points",
    "Eam point": "Get Points",
    Date: "Date",
    "Reference no": "Reference no",
    "All points record": "All points record",
    "Use points record": "Use points record",
    "Get points record": "Get points record",
    //中英文
    English: "English",
    "Traditional Chinese": "繁體中文",
    // 餐廳詳情
    "Restaurant details": "Restaurant details",
    Reservation: "Reservation",
    Delivery: "Delivery",
    // 查看地圖
    "View map": "View map",
    // 餐檯預定
    "Dining table reservation": "Dining table reservation",
    resr_mr: "Mr",
    resr_ms: "Ms",
    "Number of people": "Number of people",
    "Your name": "Your name",
    "Enter the phone number": "Enter the phone number",
    "Plase enter the contents of the memo (optional)":
      "Plase enter the contents of the memo (optional)",
    Adult: "Adult",
    Child: "Child",
    "The minimum total number is": "The minimum total number is",
    "The largest total number is": "The largest total number is",
    people: "people",
    "Please choose the number of people": "Please choose the number of people",
    "Reservation details": "Reservation details",
    "My reservation": "My reservation",
    "In appointment": "Booked",
    "Already seated": "Already seated",
    Canceled: "Cancelled",
    "reservation-table-cleaned": "completed",
    Delete: "Delete",
    "Are you sure to delete?": "Are you sure to delete?",
    "coming soon": "coming soon",
    "Reservation Record": "Reservation Record",
    //禮品詳情
    Surplus: "Surplus",
    Portion: "Portion",
    "Redeem now": "Redeem now",
    "Insufficient points": "Insufficient points",
    "Open up": "Open up",
    "Panic buying has ended": "Panic buying has ended",
    Remaining: "Remaining",
    End: "End",
    "Are you sure": "Are you sure",
    exchange: "exchange",
    "Snap up": "Snap up",
    Hour: "hour",
    Minute: "Minute",
    Second: "Second",
    "Sold out": "Sold out",
    "Recommendation code": "Recommendation code",
    "Please enter the recommendation code":
      "Please enter the recommendation code",
    "Invite to enjoy discount": "Invite to enjoy discount"
  },
  zh_cn: {},
  zh_hk: {
    // 按鈕類
    Back: "返回",
    "Warm reminder": "溫馨提示",
    confirm: "確認",
    cancel: "取消",
    male: "男",
    female: "女",
    secrecy: "保密",
    Submit: "提交",
    // 提示類
    "Please enter your mobile number": "請輸入手機號",
    "Mobile number format error": "手機號碼格式錯誤",
    "Please enter the password": "請輸入密碼",
    "Please enter a password of at least 6 digits": "請輸入至少6位数以上密碼",
    "Login...": "登入中...",
    "Login successfully": "登入成功",
    "Please check the service agreement": "請勾選服務使用協議",
    "Registration success": "註冊成功",
    "Please enter the confirmation password": "請輸入確認密碼",
    "The two passwords are inconsistent": "兩次輸入的密碼不一致",
    "Password reset succeeded": "密碼重置成功",
    Loading: "加載中...",
    "Update success": "更新成功",
    "SMS sending": "短信發送中",
    "SMS code not correct": "短信驗證碼錯誤",
    "Invalid password": "密碼錯誤",
    "Login error, user or password not correct": "登錄失敗,用戶名或密碼錯誤",
    "Identity expired": "身份已過期",
    "Network instability, please try again": "網絡不穩,請重試",
    "No more data": "暫無數據~",
    // 登錄
    Login: "登入",
    "Login to get offer": "登入會員攞優惠",
    "Mobile number": "手機號碼",
    "Enter your mobile number": "輸入手機號碼",
    Password: "密碼",
    "Enter your password within 6-20 words": "輸入6-20個字符",
    "Forget password": "忘記密碼",
    "Create Account": "註冊",
    "No account, go to register1": "沒有賬號，去",
    "No account, go to register2": "註冊",
    // 註冊
    "Welcome to join Us": "成為會員",
    "Join the membershio to get offer": "成為會員儲分享優惠",
    "Verification code": "驗證碼",
    "Enter the verification code": "請輸入驗證碼",
    "verification code": "獲取驗證碼",
    "Regain validation code": "重新獲取",
    "Please read and agree terms and conditions ": "已閱讀並同意BRANDNAME服務",
    "terms and conditions ": "使用協議",
    "to become member of The Food Story": "",
    // 详细信息
    "Please ent this following information": "點稱呼你呢?",
    "Account name": "用戶名稱",
    "Enter you account name": "請填寫你的用戶名稱",
    Mr: "性別",
    "Your birthday": "生日日期",
    "Enter your birthday": "請填寫你的生日日期",
    Email: "Email",
    "Enter your Email": "請填寫你的Email賬號",
    Skip: "略過",
    Done: "下一步",
    "Choosing birthday": "選擇生日",
    "Incorrect mailbox format": "郵箱格式不正確",
    "Choose your gender": "選擇你的性別",
    // 底部導航欄
    Membership: "會員卡",
    Shop: "品牌",
    Profile: "我的賬戶",
    // 會員卡頁
    "There are 1": "優惠券",
    coupons: "張",
    "There are 2": "積分",
    points: "分",
    // 取回密碼
    "Forget password": "取回密碼",
    Next: "下一步",
    // 更改密碼
    "Change password": "更改密碼",
    "Please enter a new password": "請輸入新的密碼",
    "Please confirm the new password": "請確認新的密碼",
    "confirm revision": "確認修改",
    "Please enter the old password": "請輸入舊的密碼",
    "Old password": "舊密碼",
    "New password": "新密碼",
    "Confirm password": "確認密碼",
    // 我的
    Birthday: "生日",
    Sexual: "性別",
    "Login password": "登錄密碼",
    Address: "收貨地址",
    "Account name 2": "名稱",
    "Email 2": "電郵",
    "Mobile number 2": "電話號碼",
    "Modify name": "修改名稱",
    "Modify email": "修改電郵",
    "Revision of birthday": "修改生日",
    "Gender modification": "修改性別",
    "Confirm logout": "確認退出登錄",
    "Please enter a name": "請輸入名稱",
    "Please enter email": "請輸入電郵",
    Logout: "登出",
    "update language": "修改語言",
    "With changing your birthday, you will not be eligible for Birthday Offer in 365 days.Proceed?":
      "如更改生日日期會影響你365天內不能獲得派發生日優惠, 是否確定繼續?",
    // 更改手機號
    "Change phone number": "更改手機號",
    "This number is registered": "此號碼已註冊",
    // 積分換購
    "Gift redemption": "積分換禮品",
    Point: "積分",
    Points: "積分",
    "Transaction record": "積分記錄",
    "Out of stoce": "已售罄",
    // 我的優惠券
    "My coupon": "我的優惠券",
    Available: "可使用",
    Used: "已使用",
    Expired: "已過期",
    "Validity period": "使用期限",
    // 下拉刷新
    "Drop down to refresh": "下拉既可刷新...",
    "Release refresh now": "釋放立即刷新...",
    "Refresh success": "刷新成功",
    "No more data": "沒有更多數據了...",
    // 優惠券詳情
    "Coupon details": "優惠券詳情",
    // 積分詳情
    "Total Bill": "總金額",
    Coupon: "使用",
    "Eam point": "獲得",
    Date: "時間",
    "Reference no": "單號",
    "All points record": "所有積分紀錄",
    "Use points record": "使用積分記錄",
    "Get points record": "獲得積分記錄",
    // 中英文
    English: "English",
    "Traditional Chinese": "繁體中文",
    // 餐廳詳情
    "Restaurant details": "餐廳詳情",
    Reservation: "訂座",
    Delivery: "外賣",
    // 查看地圖
    "View map": "查看地圖",
    // 餐檯預定
    "Dining table reservation": "餐檯預定",
    resr_mr: "先生",
    resr_ms: "女士",
    "Number of people": "人數",
    "Your name": "您的名字",
    "Enter the phone number": "輸入手機號",
    "Plase enter the contents of the memo (optional)": "請輸入備註內容(可不填)",
    Adult: "大人",
    Child: "小孩",
    "The minimum total number is": "最小可選總人數為",
    "The largest total number is": "最大可選總人數為",
    people: "人",
    "Please choose the number of people": "請選擇人數",
    "Reservation details": "訂座詳情",
    "My reservation": "我的訂座",
    "In appointment": "已訂座",
    "Already seated": "已入座",
    Canceled: "已取消",
    "reservation-table-cleaned": "已完成",
    Delete: "刪除",
    "Are you sure to delete?": "確定刪除嗎?",
    "coming soon": "即將到來",
    "Reservation Record": "訂座記錄",
    //禮品詳情
    Surplus: "尚餘",
    Portion: "份",
    "Redeem now": "立即兌換",
    "Insufficient points": "積分不足",
    "Open up": "開搶",
    "Panic buying has ended": "搶購已結束",
    Remaining: "剩餘",
    End: "結束",
    "Are you sure": "是否確認以",
    exchange: "兌換",
    "Snap up": "立即搶購",
    Hour: "時",
    Minute: "分",
    Second: "秒",
    "Sold out": "售罄",
    "Recommendation code": "邀請碼",
    "Please enter the recommendation code": "請輸入邀請碼",
    "Invite to enjoy discount": "邀請有禮"
  }
};

var lang = localStorage.foodStoryLanguage;

if (lang == undefined) {
  lang = "zh-hk";
} else {
  lang = lang.replace(/_/g, "-");
}
//将语言转为小写
lang = lang.toLowerCase();

var default_L = lang;

var _ = default_.zh_hk;
var lang_ = {
  s() {
    default_L = localStorage.foodStoryLanguage;
    if (default_L == undefined) {
      default_L = "zh-hk";
    } else {
      default_L = default_L.replace(/_/g, "-");
    }
  },
  t(obj) {
    if (default_L == "en") {
      _ = default_.en;
    }
    // else if (default_L == "zh-cn") {
    // 	_ = default_.zh_cn;
    // }
    else {
      _ = default_.zh_hk;
    }
    return _[obj];
  }
};
export default lang_;



// WEBPACK FOOTER //
// ./src/js/locales.js